import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import PublishIcon from '@material-ui/icons/Publish';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { CircularProgress, Input } from '@material-ui/core';
import {
  closeRent,
  deleteRentEndInventory,
  postRentEndInventory,
  postRentBookStartInventory,
  deleteRentBookStartInventory,
} from '../../store/rentsLld/actions';
import { KOBOO_LIGHT_RED } from '../../constants/colors';
import { BACKEND_HOST } from '../../constants/api';
import {
  getActualTimestamp,
  getDateAsString,
} from '../../services/DateService';
import { ROLE_ADMIN } from '../../constants/roles';
import KobooButton from '../Layout/KobooButton';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import StringService from '../../services/StringService';

const styles = () => ({
  buttonCell: {
    padding: 0,
    textAlign: 'left',
  },
});

const LLDRentRow = (props) => {
  const {
    rent,
    authUser,
    role,
    error,
    openDialog,
    postRentEndInventory,
    deleteRentEndInventory,
    postRentBookStartInventory,
    deleteRentBookStartInventory,
    closeRent,
    classes,
  } = props;
  let endDateString = '';
  if (rent.end_date !== null) {
    let endDate = new Date(rent.end_date * 1000);
    endDateString = getDateAsString(endDate);
  }

  const [uploadEndInventoryLoading, setUploadEndInventoryLoading] = useState(false);
  const [uploadStartInventoryLoading, setUploadStartInventoryLoading] = useState(false);
  const [closeLoading, setCloseLoading] = useState(false);
  const [rentState, setRentState] = useState(0);
  const [endInventory, setEndInventory] = useState(0);
  const [startInventory, setStartInventory] = useState(0);

  useEffect(() => {
    setCloseLoading(false);
    setUploadStartInventoryLoading(false);
    setUploadEndInventoryLoading(false);
  }, [error]);

  if (rent && endInventory === 0) {
    setEndInventory(rent.end_inventory);
    setRentState(rent.state);
    setStartInventory(rent.start_inventory);
  }

  const handleEndInventoryInputChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    setUploadEndInventoryLoading(true);
    postRentEndInventory(authUser.ma, rent.id, file).then((data) => {
      setUploadEndInventoryLoading(false);
      setEndInventory(data.end_inventory);
    });
  };

  const deleteEndInventory = () => {
    setUploadEndInventoryLoading(true);
    deleteRentEndInventory(authUser.ma, rent.id).then(() => {
      setUploadEndInventoryLoading(false);
      setEndInventory(null);
    });
  };

  const handleDeleteEndInventory = (event) => {
    event.preventDefault();
    event.stopPropagation();
    openDialog(
      'Suppression de l\'état des lieux de fin',
      'Êtes-vous certain de vouloir supprimer l\'état des lieux de fin ?',
      () => deleteEndInventory,
    );
  };

  const handleShowEndInventory = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (rent.end_inventory) {
      window.open(`${BACKEND_HOST}/${rent.end_inventory}`, '_blank');
    }
  };

  const handleStartInventoryInputChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    setUploadStartInventoryLoading(true);
    postRentBookStartInventory(authUser.ma, rent.original, file).then((data) => {
      setUploadStartInventoryLoading(false);
      setStartInventory(data.start_inventory);
    });
  };

  const deleteStartInventory = () => {
    setUploadStartInventoryLoading(true);
    deleteRentBookStartInventory(authUser.ma, rent.original).then(() => {
      setUploadStartInventoryLoading(false);
      setStartInventory(null);
    });
  };

  const handleDeleteStartInventory = (event) => {
    event.preventDefault();
    event.stopPropagation();
    openDialog(
      'Suppression de l\'état des lieux de début',
      'Êtes-vous certain de vouloir supprimer l\'état des lieux de début ?',
      () => deleteStartInventory,
    );
  };

  const handleShowStartInventory = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (rent.start_inventory) {
      window.open(`${BACKEND_HOST}/${rent.start_inventory}`, '_blank');
    }
  };

  const handleCloseRent = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setCloseLoading(true);
    let rentToSend = {
      ...rent.original,
      end_date: getActualTimestamp(),
    };
    closeRent(authUser.ma, rentToSend).then(() => {
      setCloseLoading(false);
      setRentState(2);
    });
  };

  const getState = () => {
    if (rentState === 2) {
      if (endDateString) {
        return `Cloturé le ${endDateString}`;
      } else {
        return `Cloturé`;
      }
    } else if (rentState === 0) {
      return 'Loué';
    } else {
      if (role === ROLE_ADMIN) {
        if (closeLoading) {
          return (
            <CircularProgress />
          );
        } else {
          return (
            <KobooButton
              onClick={handleCloseRent}
              type={'button'}
              style={{
                width: 'auto',
                marginLeft: '1em',
                padding: '3px 10px',
              }}
            >
              {'Cloturer'}
            </KobooButton>
          );
        }
      } else {
        return 'À cloturer';
      }
    }
  };
  return (
    <TableRow key={`table_row_${rent.id}`} hover tabIndex={-1}>
      <TableCell className={classes.buttonCell}>
        {getState()}
      </TableCell>
      {role >= ROLE_ADMIN && <TableCell>{rent.renter_info_name}</TableCell>}
      <TableCell>{rent.start_site_name}</TableCell>
      <TableCell>{StringService.formatClientName(rent.lastname, rent.firstname)}</TableCell>
      <TableCell>{rent.start_date_string}</TableCell>
      <TableCell>{rent.duration}</TableCell>
      <TableCell>{rent.is_electric}</TableCell>
      <TableCell>{rent.bike_number}</TableCell>
      <TableCell className={classes.buttonCell}>
        {uploadStartInventoryLoading
          ? <CircularProgress />
          :
          (
            startInventory
              ? <React.Fragment>
                <IconButton
                  color="primary"
                  component="span"
                  onClick={handleShowStartInventory}
                >
                  <VisibilityIcon />
                </IconButton>
                <IconButton
                  color="secondary"
                  style={{ color: KOBOO_LIGHT_RED }}
                  component="span"
                  onClick={handleDeleteStartInventory}
                >
                  <DeleteIcon />
                </IconButton>
              </React.Fragment>
              : <label htmlFor={`start-inventory-${rent.id}-${rent.book_id}-file`}>
                <Input
                  id={`start-inventory-${rent.id}-${rent.book_id}-file`}
                  accept="image/*"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={handleStartInventoryInputChange}
                />
                <IconButton
                  color="primary"
                  component="span"
                >
                  <PublishIcon />
                </IconButton>
              </label>
          )
        }
      </TableCell>
      <TableCell className={classes.buttonCell}>
        {uploadEndInventoryLoading
          ? <CircularProgress />
          : (
            endInventory
              ? <React.Fragment>
                <IconButton
                  color="primary"
                  component="span"
                  onClick={handleShowEndInventory}
                >
                  <VisibilityIcon />
                </IconButton>
                <IconButton
                  color="secondary"
                  style={{ color: KOBOO_LIGHT_RED }}
                  component="span"
                  onClick={handleDeleteEndInventory}
                >
                  <DeleteIcon />
                </IconButton>
              </React.Fragment>
              : <label htmlFor={`end-inventory-${rent.id}-file`}>
                <Input
                  id={`end-inventory-${rent.id}-file`}
                  accept="image/*"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={handleEndInventoryInputChange}
                />
                <IconButton
                  color="primary"
                  component="span"
                >
                  <PublishIcon />
                </IconButton>
              </label>
          )}
      </TableCell>
    </TableRow>
  );
};

export default compose(
  connect(
    null,
    {
      postRentBookStartInventory,
      deleteRentBookStartInventory,
      postRentEndInventory,
      deleteRentEndInventory,
      closeRent,
    },
  ),
  withStyles(styles),
)(LLDRentRow);



// WEBPACK FOOTER //
// ./src/components/LldRent/LLDRentRow.jsx